import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { Link } from "react-router-dom";

const Mycoursedetails = (props) => {
  return (
    <Modal open={props.open} onClose={props.onCloseModal} center>
      <div>
        <h3>Title: {props?.item?.sessionId?.title}</h3>
        <h3>Time: {props?.item?.sessionId?.time}</h3>
        <h3>
          <Link
            to={{
                pathname:"/live",
                state: {
                    streamUrl: props?.item?.sessionId?.streamedUrl,
                }
            }}
          >
            Click here
          </Link>{" "}
          to check stream.
        </h3>
      </div>
    </Modal>
  );
};

export default Mycoursedetails;
